import React, { useState, useEffect } from "react";
import PaymentListSheet from "../Components/PaymentListSheet";
import { getPayments, getPartnerPayments } from "../Services/paymentService";
import { paymentOptions, customStyles, RoutesPaths } from "../Router/constant";
import Select from "react-select";
import Skeleton from "../Components/SkeletonLoader";
import { NavLink } from "react-router-dom";

export default function Payment() {
  const [loading, setLoading] = useState(true);
  const [paymentUserData, setPaymentUserData] = useState(null);
  const [isPaymentModalOpen, setIsPaymentModalOpen] = useState(false);
  const [offset, setOffset] = useState(1);
  const [limit] = useState(10);
  const [selectedPayment, setSelectedPayment] = useState(null);
  const [search, setSearch] = useState("");
  const [status, setStatus] = useState("");
  const [count, setCount] = useState(0);

  const [userRole, setUserRole] = useState(() =>
    localStorage.getItem("userRole")
  );

  useEffect(() => {
    const onStorage = () => setUserRole(localStorage.getItem("userRole"));
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, []);

  useEffect(() => {
    fetchPaymentData();
  }, [offset, status, search, userRole]);

  const payments = paymentUserData?.payments || [];
  const recordsArr = Array.isArray(paymentUserData?.records)
    ? paymentUserData.records
    : [];

  const totalPages = Math.ceil(count / limit);
  const currentPage = offset;

  const fetchPaymentData = async () => {
    setLoading(true);
    try {
      let paymentResp;

      if (userRole === "admin") {
        paymentResp = await getPayments({ offset, limit, status, search });
      } else {
        paymentResp = await getPartnerPayments({ offset, limit, status, search });
      }

      const apiData = paymentResp?.data?.data || null;

      setPaymentUserData(apiData);
      setCount(apiData?.count || 0);
    } catch (error) {
      console.error("Error fetching payment:", error);
      setPaymentUserData(null);
      setCount(0);
    } finally {
      setLoading(false);
    }
  };

  const generatePagination = (currentPage, totalPages) => {
    const pages = [];

    if (totalPages <= 4) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
    } else {
      if (currentPage <= 2) {
        pages.push(1, 2, "...", totalPages - 1, totalPages);
      } else if (currentPage <= 4) {
        pages.push(3, 4, "...", totalPages - 1, totalPages);
      } else if (currentPage >= totalPages - 2) {
        for (let i = totalPages - 2; i <= totalPages; i++) pages.push(i);
      } else {
        pages.push(currentPage, currentPage + 1, "...", totalPages - 1, totalPages);
      }
    }

    return pages;
  };

  // ✅ Group payments by orderId to avoid duplicate rows
  const groupedPayments = Object.values(
    payments.reduce((acc, payment) => {
      const orderId = payment.booking?.orderId;
      if (!acc[orderId]) acc[orderId] = payment; // Keep only one payment per order
      return acc;
    }, {})
  );

  return (
    <>
      <div className="container-fluid">
        <div className="row dashboardSection">
          <div className="logisticsMenu">
            <p>
              <NavLink to={RoutesPaths.DASHBOARD}>
                <img src="/assets/img/homeIcon.svg" alt="" />
              </NavLink>
            </p>
            <img src="/assets/img/chevron-right.svg" alt="" />
            <p>
              Payment & transactions
            </p>
          </div>
          {/* Success, Failed, Pending Cards */}
          {["completed", "failed", "pending"].map((statusType, i) => {
            const titles = { completed: "Success", failed: "Failed", pending: "Pending" };
            const images = {
              completed: "/assets/img/paymentSuccess.jpg",
              failed: "/assets/img/paymentFailed.jpg",
              pending: "/assets/img/pending.png"
            };

            const countValue =
              recordsArr.find((r) => r.status === statusType)?.count || 0;

            return (
              <div className="col-md-4" key={i}>
                <div className="bookingManagement">
                  <div>
                    {loading ? (
                      <>
                        <h6 className="m-0">
                          <Skeleton width={60} />
                        </h6>
                        <div className="m-0">
                          <Skeleton width={80} />
                        </div>
                      </>
                    ) : (
                      <>
                        <h6 className="m-0">{countValue}</h6>
                        <p className="m-0">{titles[statusType]}</p>
                      </>
                    )}
                  </div>
                  <img src={images[statusType]} alt=" " className="img-fluid" />
                </div>
              </div>
            );
          })}

          <div className="col-md-12 bookingDetailsMain">
            <div className="bookingDetailsOuter">
              <div className="bookingDetailsAlign">
                <h6 className="bookingDetailsTitle p-0">Payment status</h6>

                <div className="bookingDetailsOuterRight">
                  <div className="customSelectWrapper">
                    <Select
                      className="searchInputSelect"
                      options={paymentOptions}
                      value={paymentOptions.find((opt) => opt.value === status)}
                      onChange={(selected) => setStatus(selected?.value || "")}
                      styles={customStyles}
                    />
                  </div>

                  <div>
                    <input
                      type="text"
                      placeholder="Search"
                      className="searchInput"
                      value={search}
                      onChange={(e) => {
                        setOffset(1);
                        setSearch(e.target.value);
                      }}
                    />
                  </div>
                </div>
              </div>

              <div className="TableOverFlow">
                <div className="bookingContent bookingDetailsHeader">
                  <div className="m-0 logisticswidth">Order id</div>
                  <div className="m-0 paymentActionwidth">Customer name</div>
                  <div className="m-0 logisticswidth">Customer email</div>
                  <div className="m-0 paymentActionwidth">Payment status</div>
                  <div className="m-0 paymentActionswidth">Date</div>
                  <div className="m-0 paymentActionswidth">Action</div>
                </div>

                <div>
                  {loading ? (
                    [...Array(5)].map((_, i) => (
                      <div className="bookingContent bookingContentData" key={i}>
                        <div className="m-0 logisticswidth">
                          <Skeleton width={80} />
                        </div>
                        <div className="m-0 paymentActionwidth">
                          <Skeleton width={100} />
                        </div>
                        <div className="m-0 logisticswidth">
                          <Skeleton width={120} />
                        </div>
                        <div className="m-0 paymentActionwidth">
                          <Skeleton width={100} height={24} />
                        </div>
                        <div className="m-0 paymentActionswidth">
                          <Skeleton width={80} />
                        </div>
                        <div className="m-0 paymentActionswidth">
                          <Skeleton width={50} height={24} />
                        </div>
                      </div>
                    ))
                  ) : groupedPayments.length > 0 ? (
                    groupedPayments.map((payment, index) => (
                      <div className="bookingContent bookingContentData" key={index}>
                        <div className="m-0 boldtext logisticswidth">
                          {payment.booking?.orderId}
                        </div>
                        <div className="m-0 paymentActionwidth">{payment.user?.fullName}</div>
                        <div className="m-0 logisticswidth">{payment.user?.email}</div>
                        <div className="m-0 paymentActionwidth">
                          <div className={`badgeBooking ${payment?.booking?.paymentStatus}Badge widthFitContentPayment`}>
                            <span>{payment?.booking?.paymentStatus?.charAt(0).toUpperCase() + payment?.booking?.paymentStatus?.slice(1)}
                            </span>
                          </div>
                        </div>

                        <div className="m-0 paymentActionswidth">
                          {payment.createdAt
                            ? new Date(payment.createdAt).toLocaleDateString("en-GB")
                            : "-"}
                        </div>

                        <div className="m-0 bookingActionButtons paymentActionswidth">
                          <p
                            className="m-0"
                            onClick={() => {
                              setSelectedPayment(payment);
                              setIsPaymentModalOpen(true);
                            }}
                          >
                            <img src="/assets/img/view-filled.svg" alt=" " /> View
                          </p>
                        </div>
                      </div>
                    ))
                  ) : (
                    <p className="noOrders">No payment found</p>
                  )}
                </div>
              </div>

              {count > 0 && Math.ceil(count / limit) > 1 && (
                <div className="paginationSection">
                  <p
                    onClick={() => offset > 1 && setOffset(offset - 1)}
                    style={{
                      opacity: offset > 1 ? 1 : 0.5,
                      pointerEvents: offset > 1 ? "auto" : "none",
                      cursor: offset > 1 ? "pointer" : "default"
                    }}
                  >
                    <img src="/assets/img/arrow-left.svg" alt="Previous" />
                  </p>

                  {generatePagination(currentPage, totalPages).map((page, idx) =>
                    page === "..." ? (
                      <p key={idx}>...</p>
                    ) : (
                      <p
                        key={idx}
                        onClick={() => setOffset(page)}
                        style={{
                          fontWeight: currentPage === page ? "bold" : "normal",
                          cursor: "pointer"
                        }}
                      >
                        {page}
                      </p>
                    )
                  )}

                  <p
                    onClick={() => offset < Math.ceil(count / limit) && setOffset(offset + 1)}
                    style={{
                      opacity: offset < Math.ceil(count / limit) ? 1 : 0.5,
                      pointerEvents: offset < Math.ceil(count / limit) ? "auto" : "none",
                      cursor: offset < Math.ceil(count / limit) ? "pointer" : "default"
                    }}
                  >
                    <img src="/assets/img/arrow-right.svg" alt="Next" />
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <PaymentListSheet
        payments={selectedPayment}
        isCreateOpen={isPaymentModalOpen}
        setIsCreateOpen={setIsPaymentModalOpen}
      />
    </>
  );
}
